
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/careers",
      function () {
        return require("private-next-pages/[lang]/careers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/careers"])
      });
    }
  